// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  BorderOutlined,
  BoxPlotOutlined,
  ChromeOutlined,
  DeploymentUnitOutlined,
  FileProtectOutlined,
  GatewayOutlined,
  MenuUnfoldOutlined,
  QuestionOutlined,
  SmileOutlined,
  StopOutlined,
  UserOutlined,
  HomeOutlined, 
  SolutionOutlined,
  UsergroupAddOutlined,
  DollarOutlined
} from '@ant-design/icons';

// icons
const icons = {
  ChromeOutlined,
  MenuUnfoldOutlined,
  BoxPlotOutlined,
  StopOutlined,
  BorderOutlined,
  SmileOutlined,
  GatewayOutlined,
  QuestionOutlined,
  DeploymentUnitOutlined,
  UserOutlined,
  FileProtectOutlined,
  HomeOutlined, 
  SolutionOutlined,
  UsergroupAddOutlined,
  DollarOutlined,
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const adminMenu = {
    id: 'adminMenu',
    title: <FormattedMessage id="Admin" />,
    type: 'group',
    children: [
      
      {
        id: 'admin-user-list',
        title: <FormattedMessage id="admin-user-list" />,
        type: 'item',
        url: '/user-list-view',
        icon: icons.UsergroupAddOutlined
      },
      {
        id: 'admin-price-settings',
        title: <FormattedMessage id="admin-price-settings" />,
        type: 'item',
        url: '/price-settings',
        icon: icons.DollarOutlined
      },
    ]
};

export default adminMenu;
